
import React from 'react';
import { useApp } from '@/contexts/AppContext';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Truck, MapPin, Package, Check } from 'lucide-react';

const DeliveryPage: React.FC = () => {
  const { deliveryOrders, currentUser } = useApp();
  
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Entregas</h1>
          <p className="text-muted-foreground">
            Gerencie os pedidos para entrega.
          </p>
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {deliveryOrders.length === 0 ? (
          <Card>
            <CardContent className="p-6">
              <p className="text-muted-foreground text-center">Nenhum pedido para entrega no momento.</p>
            </CardContent>
          </Card>
        ) : (
          deliveryOrders.map((order) => (
            <Card key={order.id} className="overflow-hidden">
              <CardHeader className="bg-primary/5">
                <CardTitle className="flex justify-between items-center">
                  <span>Pedido #{order.id.substring(0, 8)}</span>
                  <Truck className="h-5 w-5" />
                </CardTitle>
              </CardHeader>
              <CardContent className="p-0">
                <div className="p-6 space-y-4">
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between items-center">
                      <span className="flex items-center gap-2">
                        <Package className="h-4 w-4" /> 
                        <span>Itens:</span>
                      </span>
                      <span className="font-medium">{order.items.length}</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="flex items-center gap-2">
                        <MapPin className="h-4 w-4" /> 
                        <span>Endereço:</span>
                      </span>
                      <span className="font-medium">Rua Exemplo, 123</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span>Total:</span>
                      <span className="font-medium text-primary">
                        {order.totalAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                      </span>
                    </div>
                  </div>
                  
                  <div className="space-y-2">
                    <p className="text-sm font-medium">Itens do pedido:</p>
                    <ul className="text-sm space-y-1">
                      {order.items.map(item => (
                        <li key={item.id} className="flex justify-between">
                          <span>{item.quantity}x {item.product.name}</span>
                          <span>{(item.product.price * item.quantity).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  
                  <Button className="w-full mt-4" size="sm">
                    <Check className="mr-2 h-4 w-4" />
                    Marcar como Entregue
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))
        )}
      </div>
    </div>
  );
};

export default DeliveryPage;
